import React from 'react';

import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import useStyles from './ConnectProvider.styled';
import Container from '@material-ui/core/Container';
import i18n from 'i18n-js';
import Typography from '@material-ui/core/Typography';
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';
import { IconButton } from '@material-ui/core';
import PropTypes from 'prop-types';

const ConnectProvider = ({ step }) => {
  const classes = useStyles();

  const copy = async (text) => {
    await navigator.clipboard.writeText(text);
  };

  return (
    <Box className={classes.container}>
      <Container className="h-100">
        <Grid
          container
          className={classes.container}
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <Grid item xs={12}>
            <Typography color="textPrimary" component="div" align="left">
              <Box fontSize={16} component="h5" lineHeight={1}>
                {i18n.t('authentication.wizard.connect_with_provider')}
              </Box>
            </Typography>
            <Typography
              color="textPrimary"
              component="div"
              align="justify"
              className={classes.description}
            >
              <Box fontSize={14} mt={2} mb={4} lineHeight={1} component="div">
                <span>{i18n.t('authentication.wizard.connect_with_provider_description')}</span>
              </Box>
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography color="textPrimary" component="div" align="left">
              <Box fontSize={15} component="h6" lineHeight={1} fontWeight={500}>
                {i18n.t('authentication.wizard.fields')}
              </Box>
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              mt={3}
              className={classes.providerInfo}
            >
              <Typography color="textPrimary" component="div" align="left">
                <Box fontSize={16} component="h6" lineHeight={1}>
                  {i18n.t('authentication.wizard.callback_url')}
                </Box>
              </Typography>
              <Typography
                color="textSecondary"
                component="div"
                align="right"
                className={classes.fields}
              >
                <Box fontSize={14} component="span" lineHeight={1} mr={2}>
                  {step?.callback_url || '---'}
                </Box>
                <IconButton
                  aria-label="clone"
                  size="small"
                  onClick={() => {
                    copy(step?.callback_url || '');
                  }}
                >
                  <FileCopyOutlinedIcon fontSize="inherit" />
                </IconButton>
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              mt={3}
              className={classes.providerInfo}
            >
              <Typography color="textPrimary" component="div" align="left">
                <Box fontSize={16} component="h6" lineHeight={1}>
                  {i18n.t('authentication.wizard.issuer')}
                </Box>
              </Typography>
              <Typography
                color="textSecondary"
                component="div"
                align="right"
                className={classes.fields}
              >
                <Box fontSize={14} component="span" lineHeight={1} mr={2}>
                  {step?.issuer || '---'}
                </Box>
                <IconButton
                  aria-label="clone"
                  size="small"
                  onClick={() => {
                    copy(step?.issuer || '');
                  }}
                >
                  <FileCopyOutlinedIcon fontSize="inherit" />
                </IconButton>
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              mt={3}
              className={classes.providerInfo}
            >
              <Typography color="textPrimary" component="div" align="left">
                <Box fontSize={16} component="h6" lineHeight={1}>
                  {i18n.t('authentication.wizard.metadata_url')}
                </Box>
              </Typography>
              <Typography
                color="textSecondary"
                component="div"
                align="right"
                className={classes.fields}
              >
                <Box fontSize={14} component="span" lineHeight={1} mr={2}>
                  {step?.metadata_url || '---'}
                </Box>
                <IconButton
                  aria-label="clone"
                  size="small"
                  onClick={() => {
                    copy(step?.metadata_url || '');
                  }}
                >
                  <FileCopyOutlinedIcon fontSize="inherit" />
                </IconButton>
              </Typography>
            </Box>
          </Grid>
          {step?.has_certificate && (
            <Grid item xs={12}>
              <Box display="flex" alignItems="center" justifyContent="space-between" mt={3} mb={6}>
                <Typography
                  color="textSecondary"
                  component="div"
                  align="right"
                  className={classes.has_certificate}
                >
                  <Box fontSize={14} component="span" lineHeight={1}>
                    {i18n.t('authentication.wizard.has_certificate')}
                  </Box>
                </Typography>
              </Box>
            </Grid>
          )}
        </Grid>
      </Container>
    </Box>
  );
};

ConnectProvider.propTypes = {
  step: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    idp_endpoint: PropTypes.string,
    domains: PropTypes.arrayOf(PropTypes.string),
    issuer: PropTypes.string,
    metadata_url: PropTypes.string,
    callback_url: PropTypes.string,
    has_certificate: PropTypes.bool,
  }),
};

export default ConnectProvider;
